var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"},attrs:{"id":"my-strictly-unique-vue-image-lightbox-carousel"}},[_c('button',{on:{"click":_vm.openLightbox}},[_vm._v("Open Lightbox")]),_vm._v(" "),_c('vue-image-lightbox-carousel',{ref:"lightbox",attrs:{"show":_vm.showLightbox,"images":_vm.images},on:{"close":function($event){_vm.showLightbox = false},"change":_vm.changeImage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024aeab4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-image-lightbox-carousel/src/App.vue
// module id = 45
// module chunks = 0